import { render, staticRenderFns } from "./PersonalOverviewSummary.vue?vue&type=template&id=1aefb027&"
import script from "./PersonalOverviewSummary.vue?vue&type=script&lang=js&"
export * from "./PersonalOverviewSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports